import React from "react";

import { CheckIcon } from "shared/ui";

import { STEPS } from "features/IikoIntegration/constants";
import { useIikoIntegrationContext } from "features/IikoIntegration/context";
import { IikoIntegrationStep } from "features/IikoIntegration/types";

import {
    Card,
    Compact,
    CompactHeader,
    CompactNext,
    CompactTitle,
    Connector,
    Marker,
    Progress,
    ProgressSegment,
    Step,
    StepLabel,
    Wide,
} from "./styles";

/*
* Где пользователь находится в подключении. Кликабельны только пройденные шаги — это тот же
* переход, что и «Изменить» в свёрнутой строке; будущие шаги открываются сами по мере
* заполнения предыдущих.
* */
export const ConnectionStepper = () => {
    const state = useIikoIntegrationContext();

    const current = STEPS.find((item) => item.step === state.step);
    const next = STEPS.find((item) => item.step === state.step + 1);

    const editStep = (step: IikoIntegrationStep) => {
        if (step === 1) state.startApiLoginEditing();
        if (step === 2) state.startOrganizationEditing();
    };

    return (
        <Card>
            <Wide>
                {STEPS.map((item, index) => {
                    const done = item.step < state.step;
                    const isCurrent = item.step === state.step;
                    // Назад можно вернуться только к тому, что сворачивается в строку.
                    const clickable = done && item.step <= 2;

                    return (
                        <React.Fragment key={item.step}>
                            {index > 0 && <Connector $done={item.step <= state.step} />}

                            <Step
                                type="button"
                                $clickable={clickable}
                                onClick={() => clickable && editStep(item.step)}
                            >
                                <Marker $done={done} $current={isCurrent}>
                                    {done ? <CheckIcon /> : item.step}
                                </Marker>
                                <StepLabel $done={done} $current={isCurrent}>
                                    {item.label}
                                </StepLabel>
                            </Step>
                        </React.Fragment>
                    );
                })}
            </Wide>

            <Compact>
                <CompactHeader>
                    <CompactTitle>
                        Шаг {state.step} из {STEPS.length} · {current?.label}
                    </CompactTitle>
                    {next && <CompactNext>Далее: {next.label.toLowerCase()}</CompactNext>}
                </CompactHeader>

                <Progress>
                    {STEPS.map((item) => (
                        <ProgressSegment key={item.step} $done={item.step <= state.step} />
                    ))}
                </Progress>
            </Compact>
        </Card>
    );
};
